import { CountryCode } from "../country/countryList"

export type TaxDetails = {
   taxDescription: string
   taxPercentage: number
}

export const getTaxDetailsFromCountry = (countryCode: CountryCode): TaxDetails | {} => {
   switch (countryCode) {
      case 'NZ':
         return {
            taxDescription: 'GST',
            taxPercentage: 15
         }
      case 'AU':
         return {
            taxDescription: 'GST',
            taxPercentage: 10
         }
      case 'GB':
         return {
            taxDescription: 'VAT',
            taxPercentage: 20
         }
      default:
         return {}
   }
}

export const getTaxRateForVgc = (countryCode: CountryCode | undefined) => {
   switch (countryCode) {
      case 'AU':
         return 0.3
      case 'GB':
         return 0.25
      default:
         // default is New Zealand tax rate
         return 0.28
   }
}

export interface OrgTaxOrgDto {
   id: string
   name: string
   displayOrder: number
}

export enum TaxOrgEnum {
   ird = 'IRD',
   ato = 'ATO',
   hmrc = 'HMRC',
}

export const taxOrgs: OrgTaxOrgDto[] = [
   {
      id: '1',
      name: TaxOrgEnum.ird,
      displayOrder: 1,
   },
   {
      id: '2',
      name: TaxOrgEnum.ato,
      displayOrder: 2,
   },
   {
      id: '3',
      name: TaxOrgEnum.hmrc,
      displayOrder: 3,
   },
]
